import {Text} from '@/components-v2/atoms'

/**
 * @param {{ label: string; id?: string; isBorderVisible?: boolean }} props
 */
export const SectionTitle = ({label, id, isBorderVisible = false}) => {
  return (
    <div className={`${isBorderVisible ? 'sc-border' : ''} w-full pb-3 pt-5`}>
      <Text headingLevel={6} variant="bold" id={id ? `${id}_section_header` : undefined}>
        {label}
      </Text>
    </div>
  )
}
